<div *ngIf="!audioUrl; else showAudio">
  <div class="loader-container">
    <div class="loader"></div>
  </div>
</div>

<ng-template #showAudio>
  <audio #player controls [src]="audioUrl">
    {{ "__CALLS_AUDIO_ERROR_NOTIFICATION__" | translate }}
  </audio>
</ng-template>
